import {
  LOAD_ROLES_REQUEST,
  LOAD_ROLES_SUCCESS,
  LOAD_ROLES_FAIL,
  LOAD_ROLE_DETAIL_REQUEST,
  LOAD_ROLE_DETAIL_SUCCESS,
  LOAD_ROLE_DETAIL_FAIL,
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_RESET,
  ADD_ROLE_FAIL,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_RESET,
  UPDATE_ROLE_FAIL,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAIL,
  SEED_ROLES_REQUEST,
  SEED_ROLES_SUCCESS,
  SEED_ROLES_FAIL,
  CLEAR_ROLE_ERRORS,
} from "../constants/roleConstants";

export const rolesReducer = (state = { roles: [], loading: false }, action) => {
  switch (action.type) {
    case LOAD_ROLES_REQUEST:
      return { ...state, loading: true, error: null };

    case LOAD_ROLES_SUCCESS:
      return {
        loading: false,
        roles: Array.isArray(action.payload) ? action.payload : [],
      };

    case LOAD_ROLES_FAIL:
      return { loading: false, roles: [], error: action.payload };

    case DELETE_ROLE_REQUEST:
      return { ...state, loading: true };

    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: state.roles.filter((r) => r._id !== action.payload),
      };

    case DELETE_ROLE_FAIL:
      return { ...state, loading: false, error: action.payload };

    case SEED_ROLES_REQUEST:
      return { ...state, seeding: true };

    case SEED_ROLES_SUCCESS:
      return { ...state, seeding: false };

    case SEED_ROLES_FAIL:
      return { ...state, seeding: false, error: action.payload };

    case CLEAR_ROLE_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
};

export const roleDetailReducer = (state = { role: null, loading: false }, action) => {
  switch (action.type) {
    case LOAD_ROLE_DETAIL_REQUEST:
      return { loading: true, role: null, error: null };

    case LOAD_ROLE_DETAIL_SUCCESS:
      return { loading: false, role: action.payload };

    case LOAD_ROLE_DETAIL_FAIL:
      return { loading: false, role: null, error: action.payload };

    case CLEAR_ROLE_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
};

export const addRoleReducer = (state = { role: null, isAdded: false }, action) => {
  switch (action.type) {
    case ADD_ROLE_REQUEST:
      return { loading: true, isAdded: false, error: null };

    case ADD_ROLE_SUCCESS:
      return { loading: false, isAdded: true, role: action.payload };

    case ADD_ROLE_RESET:
      return { loading: false, isAdded: false, role: null, error: null };

    case ADD_ROLE_FAIL:
      return { loading: false, isAdded: false, error: action.payload };

    case CLEAR_ROLE_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
};

export const updateRoleReducer = (state = { isUpdated: false }, action) => {
  switch (action.type) {
    case UPDATE_ROLE_REQUEST:
      return { loading: true, isUpdated: false, error: null };

    case UPDATE_ROLE_SUCCESS:
      return { loading: false, isUpdated: true, role: action.payload };

    case UPDATE_ROLE_RESET:
      return { loading: false, isUpdated: false, role: null, error: null };

    case UPDATE_ROLE_FAIL:
      return { loading: false, isUpdated: false, error: action.payload };

    case CLEAR_ROLE_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
};
